new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        activeDesc: false,
        activeResume: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        imgVideo: '',
        
        //Carousel Settings
        currentIndex: 0,
        loopCounter: 0,
        slidesToShow: 4,
        slidesToSlide: 1,
    },
    methods: {
        updateImage(src, video) {
            console.log(video)
            if (video == true) {
                this.imgVideo = true
            }else {
                this.imgVideo = false
            }
            this.imgSrc = src;
        },

        prevSlide() {
            const list = document.getElementById('photo-list');
        },

        nextSlide() {
            const list = document.querySelectorAll('#photo-list li');
            
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        }
    },
    mounted() {
        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const videoElement = firstLi.querySelector("video source");
                const imgElement = firstLi.querySelector("img");
        
                if (videoElement) {
                    // Se houver vídeo, pega o src do <source> dentro do <video>
                    this.imgSrc = videoElement.getAttribute("src");
                    this.imgTitle = videoElement.getAttribute("title");
                    this.imgVideo = true;
                } else if (imgElement) {
                    // Se não houver vídeo, mantém o padrão para a imagem
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                    this.imgVideo = false;
                }
            }
        }        
    },
})

$(document).ready(function () {
    $('.product-detail__header--photoArea-photo').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    })

    $('.product-detail__header--photoArea-mobile').slick({
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        mobileFirst: true,
        speed: 700,
    });

    $('#photo-list').slick({
        slidesToShow: 4,
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: false,
        speed: 700,
        vertical: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToScroll: 1,
                }
            },
        ]
    })

    $('.product-detail__related--items').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false,
      mobileFirst: true,
      speed: 700,
      vertical: false,
      responsive: [
          {
              breakpoint: 991,
              settings: "unslick"
          },
      ]
    })

    $('.product__colors.attribute').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
      })
})